module.exports = __webpack_public_path__ + "img/scheduled-b.svg";